import * as Sentry from '@sentry/capacitor';
import axios from 'axios';

const APIS = [
	'https://api.ipify.org?format=json',
	'https://ipinfo.io/json',
	'https://ip-api.com/json',
];

export const getIpAddress = async () => {
	for (const api of APIS) {
		try {
			const response = await axios.get(api);
			const ip = response.data.ip || response.data.query;

			if (ip) {
				return ip;
			}
		} catch (error) {
			console.warn(`Failed to fetch IP from ${api}:`, error);
		}
	}

	Sentry.captureException(new Error('All IP fetching attempts failed.'));
	console.error('All IP fetching attempts failed.');
	return null;
};
